import { render, staticRenderFns } from "./ProductcenterHiLView.vue?vue&type=template&id=2056baa1&scoped=true"
import script from "./ProductcenterHiLView.vue?vue&type=script&lang=js"
export * from "./ProductcenterHiLView.vue?vue&type=script&lang=js"
import style0 from "./ProductcenterHiLView.vue?vue&type=style&index=0&id=2056baa1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2056baa1",
  null
  
)

export default component.exports